// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import plusCircleIcon from "@/assets/icons/plus-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PlusCircleIconProps = Omit<IconProps, "name">;

export function PlusCircleIcon(props: PlusCircleIconProps): React.ReactNode {
  return <Icon name={plusCircleIcon} {...props} />;
}
